import { accounts } from "../data/accounts";

export const fetchAccounts = async () => {
  return Promise.resolve(accounts);
}